import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { useAuth } from 'react-oidc-context';
import './App.css'
import { Box, CircularProgress } from '@mui/material';

function App() {

   const auth = useAuth();

  if (auth.isLoading) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", 
      }}
    >
      <CircularProgress size={60} />
    </Box>
  );
}
  if (auth.error) return <div>Auth error: {auth.error.message}</div>;

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <div>Redirecting to Login...</div>;
  }

  return (
      <AppRoutes />
  );
}

export default App;
